import React from 'react';
import { TestimonialsSection } from './TestimonialsSection';
const data = [{
  initials: 'CR',
  quote: 'El Token System cambió la dinámica de casa completamente. Mi esposo hace los ejercicios sin que yo se los pida. Nunca pensé que algo así fuera posible.',
  name: 'Cecilia R.',
  location: 'Mendoza',
  role: 'MegaPack + Blindaje',
  highlight: 'MegaPack + Blindaje'
}, {
  initials: 'RM',
  quote: 'Lo compré en secreto pensando que mi marido no iba a querer. Lo vio encima de la mesa y lo abrió él primero. En una semana teníamos acuerdos escritos que nunca habíamos podido tener en 10 años.',
  name: 'Roberto y Marcela M.',
  location: 'Buenos Aires',
  role: 'Casados hace 10 años'
}, {
  initials: 'PA',
  quote: 'Lo recomiendo a todas las parejas que acompaño en consulta. Es el puente entre la terapia y la vida cotidiana que siempre necesité.',
  name: 'Pablo A.',
  location: 'Medellín',
  role: 'Psicólogo de pareja'
}, {
  initials: 'SC',
  quote: 'Mi marido y yo estábamos a punto de separarnos. No por falta de amor. Por falta de herramientas. Este Megapack nos las dio. Tres meses después somos otra pareja.',
  name: 'Sofía C.',
  location: 'Santiago',
  role: 'Casada hace 7 años'
}];
export function Testimonials2() {
  return <TestimonialsSection title="❤️ MÁS PAREJAS QUE YA LO TIENEN" testimonials={data} darker data-id="element-273" />;
}